import { useState } from 'react'
import { MdAdd, MdEdit } from 'react-icons/md'

import type { FocusEvent, KeyboardEvent, ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import TextInput from '~/components/Inputs/ReactHookForm/TextInput'

import './styles.scss'

interface CategoryElementProps {
  index: number
  onEditSubCategory: (oldSubCategory: string, newSubCategory: string, index: number) => void
  subCategory: string
}

const CategoryElement = ({ index, onEditSubCategory, subCategory }: CategoryElementProps): ReactElement => {
  /** Local state */

  const [isEditing, setIsEditing] = useState(!subCategory)

  /** Handlers */

  const handleEditSubCategory = () => setIsEditing((prevState) => !prevState)

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onEditSubCategory(subCategory, event.currentTarget.value, index)
      setIsEditing(false)
    }
  }

  const handleBlur = (event: FocusEvent<HTMLInputElement, Element>) => {
    setIsEditing(false)
    onEditSubCategory(subCategory, event.target.value, index)
  }

  /** Render */

  return (
    <div className="category-element">
      {!isEditing && subCategory ? <span>{subCategory}</span> : null}
      {isEditing ? (
        <TextInput autoFocus defaultValue={subCategory} onBlur={handleBlur} onKeyDown={handleKeyDown} size="small" />
      ) : null}
      <div className="edit-icon-wrapper" onClick={handleEditSubCategory}>
        <MdEdit className="edit-icon" color="#ff5301" size={20} />
      </div>
    </div>
  )
}

interface Props {
  onAddSubCategoryClick: VoidFunction
  onEditSubCategory: (oldSubCategory: string, newSubCategory: string, index: number) => void
  subCategories: string[]
}

const SubCategoriesContainer = ({ onAddSubCategoryClick, onEditSubCategory, subCategories }: Props): ReactElement => {
  /** Render */

  return (
    <div className="sub-categories-container-component">
      <Button className="add-element-button" onClick={onAddSubCategoryClick} type="button">
        <MdAdd size={18} /> Add Category
      </Button>
      {subCategories.map((subCategory, index: number) => (
        <CategoryElement
          index={index}
          key={`${subCategory}-${index}`}
          onEditSubCategory={onEditSubCategory}
          subCategory={subCategory}
        />
      ))}
    </div>
  )
}

export default SubCategoriesContainer
